// extracted by mini-css-extract-plugin
export default {"cellError":"CellErrorIcon_cellError__2vNNt"};